import httpClient from '../http';

export type OpalInstance = {
  instance_id: string;
  instance_name: string;
  instance_nickname: string | null;
  customer_id: string;
  customer_name: string;
  product_sku: string | null;
  connected_opal_instance_id: string | null;
};

export const getUserInstances = async (): Promise<OpalInstance[]> => {
  const response = await httpClient.get<OpalInstance[]>('/backend/api/v1/user/instances');
  return response.data;
};

export const groupInstancesByOrganization = (
  instances: OpalInstance[]
): Map<string, OpalInstance[]> => {
  const grouped = new Map<string, OpalInstance[]>();
  for (const instance of instances) {
    const org = instance.customer_name;
    const existing = grouped.get(org);
    if (existing) {
      existing.push(instance);
    } else {
      grouped.set(org, [instance]);
    }
  }
  return grouped;
};
